import { defineComponent } from 'vue';
import { VxeButton } from 'vxe-pc-ui';
import { MgToolbar } from '../mg-toolbar';

const toolbarItemMaps = {
    add: {
        comp: VxeButton,
        props: {
            status: 'primary',
            content: '添加',
            icon: 'vxe-icon-add',
        },
    },
    update: {
        comp: VxeButton,
        props: {
            content: '修改',
            icon: 'vxe-icon-edit',
        },
    },
    delete: {
        comp: VxeButton,
        props: {
            status: 'danger',
            content: '删除',
            icon: 'vxe-icon-delete',
        },
    },
    refresh: {
        comp: VxeButton,
        props: {
            content: '刷新',
            icon: 'vxe-icon-refresh',
        },
    },
    export: {
        comp: VxeButton,
        props: {
            content: '导出',
            icon: 'vxe-table-icon-download',
        },
    },
    print: {
        comp: VxeButton,
        props: {
            content: '打印',
            icon: 'vxe-table-icon-print',
        },
    },
    custom: {
        comp: VxeButton,
        props: {
            content: '列配置',
            icon: 'vxe-table-icon-custom-column',
        },
    },
};

export default defineComponent({
    props: {
        items: { type: Array, default: () => [ 'append', 'update', 'delete' ] },
    },
    emits: [ 'itemClick', 'itemDropdownClick' ],
    setup (props, { emit }) {
        const handleItemClick = ({ item, $event }) => {
            emit('itemClick', { item, $event });
        };
        const handleItemDropdownClick = (params) => {
            emit('itemDropdownClick', params);
        };
        const items = props.items.map(item => {
            if (item && typeof item === 'string') {
                if (item === '--') {
                    return item;
                }
                const findItem = toolbarItemMaps[item];
                return typeof findItem === 'object'
                    ? () => (<findItem.comp {...findItem.props} onClick={(e) => handleItemClick({ item: { name: item }, $event: e })}></findItem.comp>)
                    : null;
            }
            return item;
        }).filter(item => !!item);
        return () => {
            return (
                <MgToolbar
                    items={items}
                    onItemClick={handleItemClick}
                    onItemDropdownClick={handleItemDropdownClick}
                ></MgToolbar>
            );
        };
    },
});
